import { jobOrderColNm } from "constants/jobOrderConstant";
import { shipmentColNm } from "constants/shipmentConstant";

export const shippingColNm = {
  ...shipmentColNm,
  ...jobOrderColNm,
  SampDte: "วันที่เก็บตัวอย่าง",
  InspDte: "วันที่แจ้งตรวจ",
  Brnd: "ตราสินค้า",
  Qty: "จำนวนบรรจุ",
  InvNo: "Invoice ลูกค้า",
  SONo: "เลข SO",
  Cmdy: "สินค้า",
  Temp: "อุณหภูมิ",
  POL: "Port of Loading",
  POD: "Port of Discharge",
  EDNo: "เลขที่ใบขนสินค้า",
  InvDte: null,
  ExRate: "อัตราแลกเปลี่ยน(ซื้อ)",
  ExRateInv: "อัตราแลกเปลี่ยน(ขาย)",
  OwnrAccNm: "ผู้รับผิดชอบงาน"
}